const urlMatchData = [
  {
    regex: new RegExp(/^\/blog/),
    active: 'magazine',
  },
  {
    regex: new RegExp(/^\/about/),
    active: 'about',
  },
  {
    regex: new RegExp(/^\/careers/),
    active: 'about',
  },
  {
    regex: new RegExp(/^\/insurance-checkup-and-advice/),
    active: 'checkup',
  },
  {
    regex: new RegExp(/^\/about\/contact/),
    active: 'contact',
  },
  {
    regex: new RegExp(/^\/users\/sign_in/),
    active: 'account',
  },
  {
    regex: new RegExp(/^\/users\/registration\/new/),
    active: 'account',
  },
  {
    regex: new RegExp(/^\/users\/password\/new/),
    active: 'account',
  },
];

export default urlMatchData;



// WEBPACK FOOTER //
// ../src/templates/MainNav/data/urlMatchData.js